export default "__VITE_ASSET__C566Snod__"